export enum RegisterStatus {
  REGISTERED = 'REGISTERED',
  NOT_REGISTERED = 'NOT_REGISTERED',
  NOT_REGISTERED_EDITED = 'NOT_REGISTERED_EDITED',
  ERROR = 'ERROR',
  ERROR_EDITED = 'ERROR_EDITED',
  LEGACY = 'LEGACY',
}

export const RegisterStatusPresentation: Record<RegisterStatus, string> = {
  [RegisterStatus.REGISTERED]: 'Registrado',
  [RegisterStatus.NOT_REGISTERED]: 'Sin registrar',
  [RegisterStatus.NOT_REGISTERED_EDITED]: 'Sin registrar',
  [RegisterStatus.ERROR]: 'Error al registrar',
  [RegisterStatus.ERROR_EDITED]: 'Error al registrar',
  [RegisterStatus.LEGACY]: 'N/A',
};

export function getRegisterStatusPresentation(status: RegisterStatus): string {
  return RegisterStatusPresentation[status];
}

export const RegisterStatusOrder: Record<RegisterStatus, number> = {
  [RegisterStatus.REGISTERED]: 5,
  [RegisterStatus.NOT_REGISTERED]: 1,
  [RegisterStatus.NOT_REGISTERED_EDITED]: 2,
  [RegisterStatus.ERROR]: 4,
  [RegisterStatus.ERROR_EDITED]: 3,
  [RegisterStatus.LEGACY]: 6,
};

export function getRegisterStatusOrder(status: RegisterStatus): number {
  return RegisterStatusOrder[status];
}
